import Error404 from '@/assets/SVGs/illustration/Error404';
import AppButton from '@/components/ui/AppButton';
import { useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';

function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2">
      <h1 className="text-8xl font-bold text-coal-900">404</h1>
      <h2 className="text-xl font-medium text-coal-700">Page Not Found</h2>
      <p className="mb-4 text-sm text-coal-400">The page you're looking for doesn't exist</p>
      <Error404 />
      <AppButton
        onClick={() => navigate('/')}
        theme="primary"
        size="md"
        icon={ArrowLeft}
        className="mt-4"
      >
        Back to Dashboard
      </AppButton>
    </div>
  );
}
export default NotFound;
